export const BREAKPOINTS = {
  XSmall: '(max-width: 575px)',
  Small: '(min-width: 576px) and (max-width: 767px)',
  Medium: '(min-width: 768px) and (max-width: 991px)',
  Large: '(min-width: 992px) and (max-width: 1199px)',
  XLarge: '(min-width: 1200px)',
};
